export default __webpack_public_path__ + "static/media/qink.91d0550f.png";